// extracted by mini-css-extract-plugin
export default {"struttura":"Select_struttura__o9olz"};